import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { getTitleProps, getSubtitleProps, getHeaderContentProps } from './HeaderContent.mappers.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useHeaderContent = function useHeaderContent(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    subtitle = _ref.subtitle,
    subtitleId = _ref.subtitleId,
    horizontalContentAlignment = _ref.horizontalContentAlignment;
  var titleProps = _objectSpread(_objectSpread({
    id: titleId
  }, getTitleProps(horizontalContentAlignment)), {}, {
    children: title
  });
  var subtitleProps = subtitle ? _objectSpread(_objectSpread({
    id: subtitleId
  }, getSubtitleProps(horizontalContentAlignment)), {}, {
    children: subtitle
  }) : null;
  var containerBoxProps = getHeaderContentProps(horizontalContentAlignment);
  return {
    containerBoxProps: containerBoxProps,
    titleProps: titleProps,
    subtitleProps: subtitleProps
  };
};

export { useHeaderContent };
//# sourceMappingURL=useHeaderContent.js.map
